<template>
  <div>
    <component
      :is="type"
      v-bind="meta"
      :code="meta.code || meta.id"
      :configH="isHeight"
    ></component>
  </div>
</template>
<script>
  import report from '@/views/report/index.vue'
  const kabjhgorder = require('./kabjhgorder.json') // KA北京华冠订单表
  const kabjhgstock = require('./kabjhgstock.json') // KA北京华冠库存表
  const kabjhgsale = require('./kabjhgsale.json') // KA北京华冠销售表

  const kajlforder = require('./kajlforder.json') // KA家乐福订单表

  const kashlhorder = require('./kashlhorder.json') // KA上海联华订单表
  const kashlhstock = require('./kashlhstock.json') // KA上海联华库存表
  const kashlhsale = require('./kashlhsale.json') // KA上海联华销售表

  const kasjlhorder = require('./kasjlhorder.json') // KA世纪联华订单表
  const kasjlhstock = require('./kasjlhstock.json') // KA世纪联华库存表
  const kasjlhsale = require('./kasjlhsale.json') // KA世纪联华销售表

  const kayzorder = require('./kayzorder.json') // KA银座订单表
  const kayzstock = require('./kayzstock.json') // KA银座库存表
  const kayzsale = require('./kayzsale.json') // KA银座销售表

  const kazbbmorder = require('./kazbbmorder.json') // KA中百便民订单表
  const kazbbmstock = require('./kazbbmstock.json') // KA中百便民库存表
  const kazbbmsale = require('./kazbbmsale.json') // KA中百便民销售表

  const kazbccorder = require('./kazbccorder.json') // KA中百仓储订单表
  const kazbccstock = require('./kazbccstock.json') // KA中百仓储库存表
  const kazbccsale = require('./kazbccsale.json') // KA中百仓储销售表

  const kadrfsaleitem = require('./kadrfsaleitem.json') // KA大润发品项销售表
  const kadrfsalestore = require('./kadrfsalestore.json') // KA大润发销售门店表

  const kabbgorder = require('./kabbgorder.json') // KA步步高订单表
  const kabbgsale = require('./kabbgsale.json') // KA步步高销售表

  export default {
    name: 'fe-common',
    props: {
      isHeight: {
        type: String
      }
    },
    components: {
      'report': report
    },
    data() {
      return {
        type: '',
        meta: {},
        layout: {},
        fileMap: {
          kabjhgorder: kabjhgorder,
          kabjhgstock: kabjhgstock,
          kabjhgsale: kabjhgsale,
          kajlforder: kajlforder,
          kashlhorder: kashlhorder,
          kashlhstock: kashlhstock,
          kashlhsale: kashlhsale,
          kasjlhorder: kasjlhorder,
          kasjlhstock: kasjlhstock,
          kasjlhsale: kasjlhsale,
          kayzorder: kayzorder,
          kayzstock: kayzstock,
          kayzsale: kayzsale,
          kazbbmorder: kazbbmorder,
          kazbbmstock: kazbbmstock,
          kazbbmsale: kazbbmsale,
          kazbccorder: kazbccorder,
          kazbccstock: kazbccstock,
          kazbccsale: kazbccsale,
          kadrfsaleitem: kadrfsaleitem,
          kadrfsalestore: kadrfsalestore,
          kabbgorder: kabbgorder,
          kabbgsale: kabbgsale
        }
      }
    },
    created() {
      this.init()
      console.log(this.$route)
    },
    beforeRouteUpdate(to, from, next) {
      console.log(123123)
    },
    methods: {
      init(path) {
        this.type = 'report'
        const dataJson = this.fileMap[this.$route.name].meta
        dataJson.buttons = [{
          "name": "查询",
          "event": {
            "type": "submit",
            "ajaxType": "post",
            "path": ""
          }}, {
          "name": "重置",
          "event": {
            "type": "reset",
            "path": ""
          }}]
        dataJson.buttons[0].event.path = `/wantwant-server/${this.$route.name}/list`
        dataJson.params = [{
          "name": "updateTime",
          "inputModel": "double-date-picker",
          "title": "更新时间",
          "value": {},
          "placeholder": "",
          "isHidden": false
        }]
        this.meta = dataJson
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/sales/index.vue